import $ from 'jquery';

export default function avuTracking() {
    $('.avu-footer-navigation a').on('click', function(event) {
        event.preventDefault();
        let linkText = $(this).text();
        let linkURL = $(this).attr('href');
        let footerDataLayerObject = {
            'event': 'footerLinkClick',
            'eventCategory': 'Footer Navigation',
            'eventAction': 'Footer Link Click',
            'eventLabel': linkText,
            'eventURL': linkURL,
            'footerPosition': 'Footer'
        };
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(footerDataLayerObject);
        window.location.href = linkURL;
    });
}